import React from 'react'
import StudentTable from '../../../components/AdminTable/StudentTable';
import { useTranslation } from 'react-i18next'

function Student() {
  const { t } = useTranslation();
  const header =[{
    head1: t("adminDash.student.menteeName"),
    head2: t("adminDash.student.email"),
    head3: t("adminDash.student.phone"),
    head4: t("adminDash.common.status"),
    head5: t("adminDash.common.delete"),
  }]



  return (
    <main>


      <StudentTable
       heading={t("adminDash.student.mentees")}
       SubHeading={""}
       header={header}
       />
    </main>
  )
}

export default Student
